import React, { useEffect } from 'react';

interface ImageModalProps {
  src: string;
  alt?: string;
  open: boolean;
  onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ src, alt = '', open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Program packages"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="max-h-[calc(100dvh-2rem)] w-full max-w-4xl overflow-y-auto rounded-2xl bg-white shadow-2xl">
        <div className="sticky top-0 z-10 flex justify-end bg-white/95 p-2 backdrop-blur">
          <button
            type="button"
            onClick={onClose}
            className="min-h-[44px] rounded-full bg-gray-100 px-4 text-sm font-medium text-gray-700 hover:bg-gray-200"
          >
            Close
          </button>
        </div>
        <div className="px-3 pb-3 sm:px-5 sm:pb-5">
          <img src={src} alt={alt} decoding="async" className="mx-auto h-auto max-h-[calc(100dvh-8rem)] w-full rounded object-contain" />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
